import { request } from '@umijs/max';

export * from './admin';
export * from './file';

export async function getOptions(type: API.OptionType) {
  return request<API.Response<API.Option[]>>(`/options/${type}`, {
    method: 'get',
  });
}

export async function login(params: FORM.LoginForm) {
  return request<API.Response<{ token: string }>>('/login', {
    method: 'POST',
    data: { ...params, site: 'admin' },
  });
}

export async function queryCurrentUser() {
  return request<API.Response<API.CurrentUser>>('/current-admin/info');
}

export async function getSettings(params: FORM.Pagination) {
  return request<API.Response<API.Setting[]>>('/settings', {
    params,
  });
}

export async function updateSetting(name: number, value: string) {
  return request<API.Response>(`/settings/${name}`, {
    method: 'put',
    data: {
      value,
    },
  });
}

export async function getChatSessions(params: FORM.Pagination) {
  return request<API.Pagination<API.ChatSession>>('/chat-sessions', {
    params,
  });
}

export async function getChatSessionDetail(id: string | number) {
  return request<
    API.Response<{
      messages: API.Message[];
      session: API.ChatSession;
      total: number;
    }>
  >(`/chat-sessions/${id}`);
}

export async function getTransfers(params: FORM.Pagination) {
  return request<API.Pagination<API.Transfer>>(`/transfers`, {
    params,
  });
}

export async function getChatFiles(params: FORM.Pagination) {
  return request<API.Pagination<API.ChatFile>>(`/chat-files`, {
    params,
  });
}
